<template>
    <div id="app">
        <div class='screencontainer'>
            <div class="top-menu-bar">
                <label for="hamburger" class='border-menu'></label>
                <input type="checkbox" id="hamburger" />

                <div class='poolsdropdown'>
                    <button class='simplebutton'
                        :class="{ 'loading line': !initializedContracts && !['Stats', 'FAQ', 'Donate'].includes($route.name) }">[{{
                            poolMenu[currentPool] }}]</button>
                    <div class='dropdown'>
                        <router-link to='/'>Home</router-link>
                        <router-link to='/pools'>Pools</router-link>
                        <router-link v-if="!!default_account" :to="`/pools?see=${default_account}`">My
                            dashboard</router-link>
                        <router-link to='/trade'>Trade</router-link>
                        <router-link to='/combinedstats'>Stats</router-link>
                        <a href="https://twitter.com/CurveFinance" rel='noopener noreferrer'>#Twitter</a>
                        <a href="https://t.me/curvefi" rel='noopener noreferrer'>@Telegram</a>
                        <a href="https://t.me/curveficn" rel='noopener noreferrer'>@Telegram CN</a>
                        <a href="https://discord.gg/9uEHakc" rel='noopener noreferrer'>@Discord</a>
                        <a href="https://dune.xyz/mrblock_buidl/Curve.fi" rel='noopener noreferrer'>Dune Analytics</a>
                        <a href="https://llama.airforce/#/curve/" rel='noopener noreferrer'>Llama Airforce</a>
                        <p>____________</p>
                        <button id='myAddress' class='simplebutton margintop' v-show='defaultAccount !== null'>
                            <a :href="config.explorerBaseUrl.address + default_account" rel='noopener noreferrer'> {{
                                defaultAccount }} </a>
                        </button>
                        <button class='simplebutton margintop' @click='changeWallets'>Change wallet</button>
                    </div>
                </div>

                <router-link to='/'>Root</router-link>
                <a v-show="this.config.blockchainId === 'ethereum'" href="https://dao.curve.finance">DAO</a>
                <router-link to='/combinedstats' class='showmobile'>All stats</router-link>
                <router-link :to="'/' + currentPoolRouteId"
                    v-show="this.config.blockchainId !== 'ethereum' || currentPool !== 'susd'">Buy and
                    sell</router-link>
                <router-link :to="'/' + currentPoolRouteId + '/deposit'"
                    v-show="this.config.blockchainId !== 'ethereum' || currentPool !== 'susd'">Deposit</router-link>
                <router-link :to="'/' + currentPoolRouteId + '/withdraw'">Withdraw/Claim</router-link>
                <router-link :to="'/' + currentPoolRouteId + '/withdraw_old'"
                    v-show="this.config.blockchainId === 'ethereum' && currentPool == 'compound' && oldBalance > 0">Withdraw
                    old</router-link>
                <router-link to="/susd/withdraw"
                    v-show="this.config.blockchainId === 'ethereum' && currentPool === 'susdv2' && oldBalance > 0">Withdraw
                    old</router-link>
                <router-link v-show="this.config.blockchainId === 'ethereum' && currentPool !== 'susd'"
                    :to="'/' + currentPoolRouteId + '/stats'">Stats</router-link>
                <router-link v-show="this.config.blockchainId === 'ethereum' && currentPool !== 'susd'"
                    :to="'/' + currentPoolRouteId + '/profit'">Profit</router-link>
                <router-link v-show="this.config.blockchainId === 'ethereum'"
                    :to="'/curvepay/' + currentPool">Pay</router-link>
                <div class='poolsdropdown right'>
                    <span>?</span>
                    <div class='dropdown'>
                        <a :href="config.explorerBaseUrl.address + this.poolAddress" rel='noopener noreferrer'>Pool
                            contract</a>
                        <a :href="config.explorerBaseUrl.address + this.tokenAddress" rel='noopener noreferrer'>Token
                            contract</a>
                        <p>____________</p>
                        <router-link to="/whitepaper">Whitepaper</router-link>
                        <router-link to="/audits">Audits</router-link>
                        <router-link to="/events">Events</router-link>
                        <router-link :to="'/' + currentPoolRouteId + '/risks'">Risks</router-link>
                        <router-link to="/bugbounty">Bug Bounty</router-link>
                        <router-link :to="'/' + currentPoolRouteId + '/faq'">FAQ</router-link>
                        <router-link to="/integrations">Integrations</router-link>
                        <router-link to="/devdocs">Developer Docs</router-link>
                        <router-link to="/careers">Careers</router-link>
                        <a href='https://news.curve.finance' rel='noopener noreferrer'>News</a>
                        <a href='https://resources.curve.finance' rel='noopener noreferrer'>Resources</a>
                        <p>____________</p>
                        <a :href="'https://github.com/curvefi/curve-contract/tree/pool_' + gitBranches[currentPool]"
                            rel='noopener noreferrer'>git@</a>
                    </div>
                </div>
                <a href="https://dao.curve.finance" class='showmobile'>DAO</a>
                <router-link to="/whitepaper" class='showmobile'>Whitepaper</router-link>
                <router-link to="/audits" class='showmobile'>Audits</router-link>
                <router-link to="/events" class='showmobile'>Events</router-link>
                <router-link :to="'/' + currentPoolRouteId + '/faq'" class='showmobile'>FAQ</router-link>
                <router-link to="/integrations" class='showmobile'>Integrations</router-link>
                <router-link to="/bugbounty" class='showmobile'>Bug Bounty</router-link>
                <a href='https://news.curve.finance' rel='noopener noreferrer' class='showmobile'>News</a>
                <a href='https://resources.curve.finance' rel='noopener noreferrer' class='showmobile'>Resources</a>
                <a :href="'https://github.com/curvefi/curve-contract/tree/pool_' + gitBranches[currentPool]"
                    class='showmobile' rel='noopener noreferrer'>git@</a>
                <button class='simplebutton showmobile' @click='changeWallets'>Change wallet</button>
            </div>
            <div id="screen">
                <div :class="{ 'blue window': true, [$route.name]: true }">
                    <h1><img :src="logoSrc" alt="🌀 Curve"></h1>
                </div>
                <HighGasWarning />
                <CoingeckoIncidentNotice />
                <HarmonyNotice />
                <div class="error window half-width info" id="error-window" v-show='error'>
                    {{ error }}
                </div>
                <div class='info-message gentle-message window half-width gentle-message' v-show='hasConnectedWallet'>
                    You haven't connected a wallet. <button @click='changeWallets'>Connect wallet</button>
                </div>
                <div class='simple-error window' v-show='plsReturn'>
                    Your recent withdrawal from Curve resulted in getting 1000 more USDT because of another user
                    mistakenly transferring funds to the contract.
                    If you wish to return them - please contact us on <a
                        href='https://twitter.com/CurveFinance'>Twitter</a>/<a
                        href='https://t.me/curvefi'>Telegram</a>/<a href="https://discord.gg/9uEHakc"
                        rel='noopener noreferrer'>@Discord</a>. Thank you!
                </div>
                <div class='simple-error window' v-show='plsReturn2'>
                    Your recently made a huge arb in USDK pool where someone incurred a huge loss.
                    If you wish to return partially - please contract us on
                    <a href='https://twitter.com/CurveFinance'>Twitter</a>/<a
                        href='https://t.me/curvefi'>Telegram</a>/<a href="https://discord.gg/9uEHakc"
                        rel='noopener noreferrer'>@Discord</a>. Thank you!
                </div>
                <router-view />
            </div>

            <balances-info :class='{ [$route.name]: true }' :bal_info='bal_info' :total='balTotal' :l_info='l_info'
                :totalShare='totalShare' :staked_info='staked_info' :totalStake='totalStake' :fee='fee'
                :admin_fee='admin_fee' :currencies='currencies'
                v-if="!['Stats', 'FAQ', 'Donate', 'Root', 'CombinedStats'].includes($route.name)" />
        </div>
        <footer>
            <a :href="config.explorerBaseUrl.address + this.poolAddress" rel='noopener noreferrer'>Pool contract</a>
            <a :href="config.explorerBaseUrl.address + this.tokenAddress" rel='noopener noreferrer'>Token contract</a>
            <a href="https://twitter.com/CurveFinance" rel='noopener noreferrer'>#Twitter</a>
            <a href="https://t.me/curvefi" rel='noopener noreferrer'>@Telegram</a>
            <a href="https://t.me/curveficn" rel='noopener noreferrer'>@Telegram CN</a>
            <a href="https://discord.gg/9uEHakc" rel='noopener noreferrer'>@Discord</a>
            <a href='https://news.curve.finance' rel='noopener noreferrer'>News</a>
            <a href='https://resources.curve.finance' rel='noopener noreferrer'>Resources</a>
            <a href="https://dune.xyz/mrblock_buidl/Curve.fi" rel='noopener noreferrer'>Dune Analytics</a>
            <a href="https://github.com/curvefi/curve-contract">git@</a>
            <router-link to="/devdocs">Developer Docs</router-link>
        </footer>
    </div>
</template>

<script>
import BalancesInfo from '../components/BalancesInfo.vue'
import { getters, contract as currentContract, changeContract, poolMenu } from '../contract'
import init, { onboard, changeWallets } from '../init'
import { contractAbis } from '@/constants/abis'
import pools from '@/constants/pools'
import config from '@/constants/config'
import HighGasWarning from '@/components/common/HighGasWarning.vue'
import CoingeckoIncidentNotice from '@/components/common/CoingeckoIncidentNotice.vue'
import HarmonyNotice from '@/components/common/HarmonyNotice.vue'

export default {
    metaInfo() {
        return {
            title: 'Curve.finance :: ' + pools.getById(this.currentPool).pageMetaData.title,
        }
    },
    data: () => ({
        config,
        pools,
        gitBranches: {
            compound: 'compound',
            usdt: 'usdt',
            iearn: 'y',
            y: 'y',
            busd: 'busd',
            susd: 'susd_vulnerable',
            susdv2: 'susd_plain',
            pax: 'pax',
            tbtc: 'tbtc',
            pbtc: 'pbtc',
            ren: 'ren',
            sbtc: 'renbtc_sbtc',
            hbtc: 'hbtc',
            '3pool': 'pool_3',
        }
    }),
    components: {
        BalancesInfo,
        HighGasWarning,
        CoingeckoIncidentNotice,
        HarmonyNotice,
    },
    computed: {
        allGetters() {
            return getters;
        },
        ...getters,
        poolMenu() {
            return poolMenu;
        },
        poolAddress() {
            return contractAbis[this.currentPool].swap_address
        },
        tokenAddress() {
            return contractAbis[this.currentPool].token_address
        },
        publicPath() {
            return process.env.BASE_URL
        },
        logoSrc() {
            // if(!currentContract.swapbtc && currentContract.currentContract != 'linkusd') return this.publicPath + config.logoPath
            // else return this.publicPath + 'logo_ren_beta_optimized.svg'
            return this.publicPath + config.logoPath
        },
        hasConnectedWallet() {
            return this.default_account == '0x0000000000000000000000000000000000000000'
                && !['Donate', 'StatsDaily', 'Audits', 'Stats', 'Contracts', 'FAQ', 'RootFAQ'].includes(this.$route.name)
        },
        plsReturn() {
            return currentContract.currentContract.toLowerCase() == '0x72c20f89008729c91b6bb85f3104fda942494cef'.toLowerCase()
        },
        plsReturn2() {
            return currentContract.currentContract.toLowerCase() == '0xB2398330970C7cAd95535D076BA3f64Cc6aFd43d'.toLowerCase()
        },
        defaultAccount() {
            if (!this.default_account || this.default_account == '0x0000000000000000000000000000000000000000') return null
            return this.default_account.slice(0, 6) + '...' + this.default_account.slice(-6)
        },
    },
    methods: {
        changePools(pool) {
            console.log('changePools');
            changeContract(pool)
        },
        async changeWallets() {
            changeWallets()
        },
    },
}
</script>

<style>
.margintop {
    margin-top: 0.3em;
}

#myAddress a {
    display: inline;
    margin: 0;
    padding: 0;
    color: white;
}

a.showmobile {
    display: none;
}

@media only screen and (min-device-width : 320px) and (max-device-width : 730px) {
    #hamburger:checked~a.showmobile {
        display: block;
    }

    .blue.window.half-width,
    .info-message.window.half-width {
        width: 90%;
    }
}

h1>img {
    height: 52.125px;
}

.simple-error.window {
    box-shadow: none;
}

.CRV a:hover,
.CRV a:visited {
    color: white;
}
</style>
